"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useParams } from "next/navigation";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useContractorFiltersStore } from "@/store/store";
import { fetchLeadGenProfiles } from "../../../_api/contractors";
import { CITIES } from "../../../_constants/cities";
import { buildLeadGenProfileFilters } from "../_components/filterConfig";
import { PAGE_SIZE, SORT } from "../_constants/listingQuery";
const MIN_SEARCH_LENGTH = 3;
export function useContractorProfiles(debouncedSearchQuery, initialPage) {
  const $ = _c(36);
  const {
    appliedFilters
  } = useContractorFiltersStore();
  const {
    city: cityParam
  } = useParams();
  let t0;
  if ($[0] !== cityParam) {
    t0 = CITIES.find(entry => entry.id === cityParam)?.apiName;
    $[0] = cityParam;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const city = t0;
  let built;
  if ($[2] !== appliedFilters.selected || $[3] !== city || $[4] !== debouncedSearchQuery) {
    built = buildLeadGenProfileFilters(appliedFilters.selected);
    if (city) {
      built.city = city;
    }
    let t1;
    if ($[6] !== debouncedSearchQuery) {
      t1 = debouncedSearchQuery?.trim();
      $[6] = debouncedSearchQuery;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    const trimmedQuery = t1;
    if (trimmedQuery && trimmedQuery.length >= MIN_SEARCH_LENGTH) {
      built.profileName = trimmedQuery;
    }
    $[2] = appliedFilters.selected;
    $[3] = city;
    $[4] = debouncedSearchQuery;
    $[5] = built;
  } else {
    built = $[5];
  }
  const filters = built;
  let t1;
  if ($[8] !== initialPage) {
    t1 = initialPage ? {
      pages: [initialPage],
      pageParams: [1]
    } : undefined;
    $[8] = initialPage;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const seed = t1;
  let t2;
  if ($[10] !== filters || $[11] !== seed) {
    t2 = Boolean(seed) && Object.keys(filters).length === 1 && Boolean(filters.city);
    $[10] = filters;
    $[11] = seed;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const usesInitialPage = t2;
  let t3;
  let t4;
  if ($[13] !== filters) {
    t3 = ["fevicol-inhomz-contractors", filters];
    t4 = t5 => {
      const {
        pageParam: t6
      } = t5;
      const pageParam = t6 === undefined ? 1 : t6;
      return fetchLeadGenProfiles({
        page: pageParam,
        limit: PAGE_SIZE,
        sort: SORT,
        filters
      });
    };
    $[13] = filters;
    $[14] = t3;
    $[15] = t4;
  } else {
    t3 = $[14];
    t4 = $[15];
  }
  let t5;
  if ($[16] !== seed) {
    t5 = seed && {
      placeholderData: previous => previous ?? seed
    };
    $[16] = seed;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== seed || $[19] !== usesInitialPage) {
    t6 = usesInitialPage && {
      initialData: seed,
      staleTime: 60000
    };
    $[18] = seed;
    $[19] = usesInitialPage;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
    t7 = {
      queryKey: t3,
      queryFn: t4,
      getNextPageParam: _temp,
      initialPageParam: 1,
      ...t5,
      ...t6
    };
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useInfiniteQuery(t7);
  let t8;
  if ($[26] !== data?.pages) {
    t8 = data?.pages?.flatMap(_temp2) || [];
    $[26] = data?.pages;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  const contractors = t8;
  const total = data?.pages?.[0]?.pagination?.total ?? 0;
  let t9;
  if ($[28] !== contractors || $[29] !== error || $[30] !== fetchNextPage || $[31] !== hasNextPage || $[32] !== isFetchingNextPage || $[33] !== isLoading || $[34] !== total) {
    t9 = {
      contractors,
      total,
      isLoading,
      error,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage
    };
    $[28] = contractors;
    $[29] = error;
    $[30] = fetchNextPage;
    $[31] = hasNextPage;
    $[32] = isFetchingNextPage;
    $[33] = isLoading;
    $[34] = total;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  return t9;
}
function _temp2(page) {
  return page?.data || [];
}
function _temp(lastPage) {
  const pagination = lastPage?.pagination;
  if (!pagination?.page || !pagination?.pageCount) {
    return;
  }
  return pagination.page < pagination.pageCount ? pagination.page + 1 : undefined;
}